import {Component} from "@angular/core";

@Component({
    selector: 'cm-header',
    templateUrl: './header.component.html',
    host: {'class': 'header'}
})
export class HeaderComponent {

    constructor() {
    }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-paiement-factures/digicerba-paiement-factures-web/src/angular/cerba/src/app/pages/cerba/header/header.component.ts